import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/zoeken')({
  validateSearch: (search: Record<string, unknown>) => ({
    q: typeof search.q === 'string' ? search.q.trim() : '',
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/kaart',
      search: search.q ? { q: search.q } : {},
      replace: true,
    });
  },
});
